import { HttpInterceptorFn, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { SessionService } from '../services/session/session.service'; // Assuming you'll use SessionService for token

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const sessionService = inject(SessionService); // Inject your SessionService
  let clonedReq;
  if (!(req.body instanceof FormData)) {
    // Clone the request to add new headers
    clonedReq = req.clone({
      setHeaders: {
        "Content-Type": "application/json",
        Accept: "application/json", // Good practice to include Accept header
      },
    });
  } else {
    // Clone the request to add new headers
    clonedReq = req.clone({
      setHeaders: {
        Accept: "application/json", // Good practice to include Accept header
      },
    });
  }

  // If you have an authentication token (e.g., Bearer token), add it here
  const authToken = sessionService.getToken(); // Get token from your SessionService
  if (authToken) {
    clonedReq = clonedReq.clone({
      setHeaders: {
        Authorization: `Bearer ${authToken}`
      }
    });
  }

  return next(clonedReq);
};